<template>
  <v-container>
    <h1>Din bestilling kunne ikke gjennomføres.</h1>
  </v-container>
</template>

<script>
import backend from "@/backend";

export default {
  name: "VendorOrderFailed",

  props: {
    vendorId: {
      type: String,
      required: true,
    },
  },

  data: function () {
    return {
      vendor: {},
    };
  },

  async created() {
    this.$emit("handleIsAdmin", false);
    this.$emit("handleIsVendor", true);

    this.vendor = await backend.get(`vendors/${this.vendorId}/`);
  },
};
</script>
